import React, { Component } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/GenericServices/FilterRequestsGS.css';
import defautRadioButton from '../../../Assets/ProfileManagement/Assets-Desktop/defautRadioButton.svg'
import selectedRadioButton from '../../../Assets/TerminalHandling/radio-checked.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import unchecked from '../../../Assets/TruckVisits/Assets/unchecked-box.svg';
import checked from '../../../Assets/NominateRequest/selectedCheckBox.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { GET_ALL_COMPANY_NAMES, SERVICE_PREFERENCES } from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';

class FilterRequestsGS extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            Location: 'Addington - Durban',
            CancellationPolicyData: [
                { Policy: "Flexible" }, { Policy: "Moderate" }, { Policy: "Strict" }],
            SelectedCancellationPolicy: [],
            PaymentMethodData: [
                { Method: "Via App" }, { Method: "Outside App" }],
            SelectedPaymentMethod: [],
            TruckTypeRequirementsdata: [
                { Type: "Tautliner" }, { Type: "Flatbed" }, { Type: "Refrigerated" }, { Type: "Lowbed" },
                { Type: "Bottom Dumper" }, { Type: "Walking Floor" }, { Type: "Side Tipper" }, { Type: "Pantech" },
                { Type: "Rigid Body" }, { Type: "Dropside" }, { Type: "Skeletal" }, { Type: "Flatbed Container" },
                { Type: "Volumax" }, { Type: "imer Trailer" }, { Type: "Dry Bulk Cement Tanker" }, { Type: "Tanker" },
                { Type: "Back End Tipper" }],
            SelectedTruckType: [],
            RadioFlag: false,
            errors: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        if (!this.state.RadioFlag) {
            let a = this.state.SelectedCancellationPolicy;
            a[0] = true;
            this.setState({ SelectedCancellationPolicy: a, RadioFlag: true })
        }
    }
    handleClickOutside = event => { };
    toggleCancellationRefundpolicyChek = () => {
        this.setState({ AcceptCancellationRefundpolicy: !this.state.AcceptCancellationRefundpolicy })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleApply = () => { }
    render() {
        return (
            <div class="FilterRequestsOutercolor">
                <MetaDecorator title={TitleDescription.FilterRequestGSTitle} description={TitleDescription.FilterRequestGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="FilterRequestsOuterDivcss">
                    <div id="FilterRequestsBoxDiv">
                        <nav class="FilterRequestsNavbar">
                            <div className="FilterRequestsNavbarName">
                                <small id="FilterRequestsNavbarText">Filter Requests</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="FilterRequestsMidPartition">
                            <div class="FilterRequestsHeadingText">Location</div>
                            <div class="FilterRequestLocationCard">
                                <small class="FilterRequestLocationtext">{this.state.Location}</small>
                            </div>
                            <div class="FilterRequestsHeadingText">Cancellation Policy</div>
                            <div class="FilterRequestLocationCard">
                                <div class="FilterRequestsCancellationDiv">
                                    {(this.state.CancellationPolicyData.map((val, index) => {
                                        return (
                                            <div class="FilterRequestsCPolicyDiv" id={(index + 1) % 3 === 0 && "FilterRequestsCPolicyThird"}>
                                                <img
                                                    src={this.state.SelectedCancellationPolicy[index] ?
                                                        selectedRadioButton :
                                                        defautRadioButton
                                                    }
                                                    width="22"
                                                    height="22"
                                                    id="FilterRequestsSelect_img"
                                                    onClick={() => {
                                                        let a = this.state.SelectedCancellationPolicy;
                                                        a = a.map(x => false);
                                                        a[index] = !this.state.SelectedCancellationPolicy[index];
                                                        this.setState({ SelectedCancellationPolicy: a });
                                                    }}
                                                />
                                                <div class="FilterRequestsRadioTextDiv">{val.Policy}</div>
                                            </div>);
                                    }))}
                                </div>
                            </div>
                            <div class="FilterRequestsHeadingText">Payment Method</div>
                            <div class="FilterRequestLocationCard">
                                <div class="FilterRequestsCancellationDiv">
                                    {(this.state.PaymentMethodData.map((val, index) => {
                                        return (
                                            <div class="FilterRequestsCPolicyDiv" >
                                                <img
                                                    src={this.state.SelectedPaymentMethod[index] ?
                                                        checked :
                                                        unchecked
                                                    }
                                                    width="22"
                                                    height="22"
                                                    id="FilterRequestsSelect_img"
                                                    onClick={() => {
                                                        let a = this.state.SelectedPaymentMethod;
                                                        a[index] = !this.state.SelectedPaymentMethod[index];
                                                        this.setState({ SelectedPaymentMethod: a });
                                                    }}
                                                />
                                                <div class="FilterRequestsRadioTextDiv">{val.Method}</div>
                                            </div>);
                                    }))}
                                </div>
                            </div>
                            <div id='FilterRequestsonBtnDiv' class="FilterRequestsBtnDiv">
                                <Button class="FilterRequestsBtnCss" onClick={this.handleApply}>
                                    <small class="FilterRequestsBtntext">Apply</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="FilterRequestsFooterUnfixed">
                    <Footer />
                </div>
                <div class="FilterRequestsFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default FilterRequestsGS;